import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: "/Index"
    },
    {
      path: '/',
      redirect: "/Index",
      component: () => import("../components/Index"),
      meta: {title: "主页"}
    },
    {
      path: '/Index',
      name: 'index',
      component: () => import("../components/Index"),
      meta: {title: "主页"}
    },

    {
      path: '/TokenLogin',
      name: 'TokenLogin',
      component: () => import("../components/TokenLogin/TokenLogin"),
      meta: {title: "Token登录"}
    },

    {
      path: '/register',
      name: 'register',
      component: () => import("../components/register/register"),
      meta: {title: "手机注册"}
    },
    {
      path: '/registermail',
      name: 'registermail',
      component: () => import("../components/register/registermail"),
      meta: {title: "邮箱注册"}
    },
    {
      path: '/TokenLoginAgain',
      name: 'TokenLoginAgain',
      component: () => import("../components/TokenLogin/TokenLoginAgain"),
      meta: {title: "Token登录"}
    },
    {
      path: '/agree',
      name: 'agree',
      component: () => import("../components/register/agree"),
      meta: {title: "用户协议"}
    },
    {
      path: '/service',
      name: 'service',
      component: () => import("../components/register/service"),
      meta: {title: "服务协议"}
    },
    {
      path: '/devAdd',
      name: 'devAdd',
      component: () => import("../components/register/devAdd"),
      meta: {title: "设备新增"}
    },
    {
      path: '/getpassword',
      name: 'getpassword',
      component: () => import("../components/forget/getpassword"),
      meta: {title: "找回密码"}
    },
    {
      path: '/newpassword',
      name: 'newpassword',
      component: () => import("../components/forget/newpassword"),
      meta: {title: "新密码"}
    },
    {
      path: '/loginout',
      name: 'loginout',
      component: () => import("../components/loginout"),
      meta: {title: "登出"}
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js